import React, { Component, createRef } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import PropTypes from 'prop-types';
import { Button, Modal } from 'reactstrap';

import './DatePicker.scss';

import { dateDDMMYYFormat, Dropdown, dateYYYYMMDD } from '../../helpers';

export default class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'from': props.fromDate ? new Date(props.fromDate) : null,
      'to': props.toDate ? new Date(props.toDate) : null,
      'showCalendar': false,
      'selectType': props.selectType ? props.selectType : null, // 1 = this day, 2 = this week, 3 = this month, 4 = this year
    };
    this.dropdown = createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fromDate, toDate } = this.props;

    if (nextProps.fromDate !== fromDate || nextProps.toDate !== toDate) {
      return this.setState({ 'from': new Date(nextProps.fromDate), 'to': new Date(nextProps.toDate), 'selectType': nextProps.selectType });
    }
  }

  handleSelectDate = day => {
    try {
      const { datePickerType } = this.props;

      if (datePickerType === 2) {
        return this.setState({ 'from': day, 'to': day });
      }
      const { from, to } = DateUtils.addDayToRange(day, this.state);

      if (from && to) {
        return this.setState({ from, to });
      } else if (!from) {
        return this.setState({ 'from': to, to });
      } else if (!to) {
        return this.setState({ from, 'to': from });
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  handleShowItem = () => {
    const { showCalendar } = this.state;
    const { template } = this.props;

    if (template) {
      return this.dropdown.current.handleShowItem();
    } else if (showCalendar) {
      this.handleResetSelectDate();
    }

    return this.setState({ 'showCalendar': !showCalendar });
  }

  handleResetSelectDate = () => this.setState({
    'from': new Date(this.props.fromDate),
    'to': new Date(this.props.toDate),
    'selectTypeDate': this.props.selectType,
    'showCalendar': !this.state.showCalendar,
  });

  handleConfirmDate = () => {
    const { from, to } = this.state;

    this.setState({ 'showCalendar': false, 'selectType': null });
    return this.props.handleSelectDate(from, to, null);
  }

  handleSelectRange = key => {
    const currentDate = new Date();

    this.dropdown.current.handleShowItem();
    if (key === 1) { // one day
      this.setState({ 'showCalendar': false, 'selectType': 1 });
      return this.props.handleSelectDate(currentDate, currentDate, 1);
    } else if (key === 2) { // one week
      this.setState({ 'showCalendar': false, 'selectType': 2 });
      return this.props.handleSelectDate(
        new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay())),
        new Date(currentDate.setDate((currentDate.getDate() - currentDate.getDay()) + 6)),
        2,
      );
    } else if (key === 3) { // one month
      this.setState({ 'showCalendar': false, 'selectType': 3 });
      return this.props.handleSelectDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0),
        3,
      );
    } else if (key === 4) { // one year
      this.setState({ 'showCalendar': false, 'selectType': 4 });
      return this.props.handleSelectDate(
        new Date(currentDate.getFullYear(), 0, 1),
        new Date(currentDate.getFullYear(), 12, 0),
        4,
      );
    } else if (key === 5) { // all day
      this.setState({ 'showCalendar': false, 'selectType': 5 });
      return this.props.handleSelectDate(
        null,
        null,
        5,
      );
    }
    return this.setState({ 'showCalendar': false, 'selectType': null });
  }

  handleCustomRangDate = () => {
    this.dropdown.current.handleShowItem();
    this.setState({ 'showCalendar': true });
  }

  handlsShowSelectType = () => {
    const { selectType } = this.state;

    switch (selectType) {
      case 1:
        return 'วันนี้';
      case 2:
        return 'สัปดาห์นี้';
      case 3:
        return 'เดือนนี้';
      case 4:
        return 'ปีนี้';
      case 5:
        return 'แสดงทั้งหมด';
      default:
        return null;
    }
  }

  handlePaginationDatePicker = data => (
    <div className={data.className}>
      <span
        id="datepicker-previous-month"
        tabIndex="0"
        role="button"
        aria-label={data.previousMonth}
        className={data.showPreviousButton ? data.classNames.navButtonPrev : `${data.classNames.navButtonPrev} ${data.classNames.navButtonInteractionDisabled}`}
        onClick={data.showPreviousButton ? () => data.onPreviousClick() : null}
      />
      <span
        id="datepicker-next-month"
        tabIndex="0"
        role="button"
        aria-label={data.nextMonth}
        className={data.showNextButton ? data.classNames.navButtonNext : `${data.classNames.navButtonNext} ${data.classNames.navButtonInteractionDisabled}`}
        onClick={data.showNextButton ? () => data.onNextClick() : null}
      />
    </div>
  );

  handleShowItemType = () => {
    try {
      const { datePickerType } = this.props;
      const { selectType } = this.state;

      if (datePickerType === 2) {
        return (
          <>
            <div className={`item${selectType === 1 ? ' active' : ''}`} id="date-picker-select-today" onClick={() => this.handleSelectRange(1)}>
              วันนี้
            </div>
            <div className="item" id="date-picker-select-custom" onClick={this.handleCustomRangDate}>
              <span>เลือกวันที่</span>
              <span className="icon far fa-calendar" />
            </div>
          </>
        );
      }

      return (
        <>
          <div className={`item${selectType === 1 ? ' active' : ''}`} id="date-picker-select-today" onClick={() => this.handleSelectRange(1)}>
            วันนี้
          </div>
          <div className={`item${selectType === 2 ? ' active' : ''}`} id="date-picker-select-tomorrow" onClick={() => this.handleSelectRange(2)}>
            สัปดาห์นี้
          </div>
          <div className={`item${selectType === 3 ? ' active' : ''}`} id="date-picker-select-month" onClick={() => this.handleSelectRange(3)}>
            เดือนนี้
          </div>
          <div className={`item${selectType === 4 ? ' active' : ''}`} id="date-picker-select-year" onClick={() => this.handleSelectRange(4)}>
            ปีนี้
          </div>
          <div className="item" id="date-picker-select-custom" onClick={this.handleCustomRangDate}>
            <span>เลือกช่วงเวลา</span>
            <span className="icon far fa-calendar" />
          </div>
        </>
      );
    } catch (error) {
      return null;
    }
  }

  handleShowHeader = () => {
    try {
      const { datePickerType } = this.props;
      const { from, to } = this.state;

      if (datePickerType === 2) {
        return (
          <>
            <span className="input-title">วันที่</span>
            <span className="dummy-input">
              <span className={`text${from ? '' : ' placeholder'}`} id="datepicker-from-date">
                {from ? dateDDMMYYFormat(from) : 'วันที่'}
              </span>
              <span className="icon far fa-calendar" />
            </span>
          </>
        );
      }

      return (
        <>
          <span className="input-title">ตั้งแต่วันที่</span>
          <span className="dummy-input">
            <span className={`text${from ? '' : ' placeholder'}`} id="datepicker-from-date">
              {from ? dateDDMMYYFormat(from) : 'ตั้งแต่'}
            </span>
            <span className="icon far fa-calendar" />
          </span>
          <span className="input-title ml">ถึง</span>
          <span className="dummy-input">
            <span className={`text${to ? '' : ' placeholder'}`} id="datepicker-to-date">
              {to ? dateDDMMYYFormat(to) : 'ถึง'}
            </span>
            <span className="icon far fa-calendar" />
          </span>
        </>
      );
    } catch (error) {
      return null;
    }
  }

  handleDayClick = (day, modifiers = {}) => {
    try {
      const { handleSelectDate } = this.props;
      if (modifiers.disabled) {
        return null;
      }
      handleSelectDate(day);
    } catch (error) {
      return null;
    }
  }

  render() {
    const { from, to, showCalendar, selectType } = this.state;
    const { fromDate, toDate, placeholder, allDay, id, datePickerType, template, value, fromMonth, toMonth, disabledDays, disabled, className } = this.props;

    if (template) {
      return (
        <div className={`DatePicker template-${template}${className ? className : ''}`}>
          <Dropdown
            id={id}
            template="d-icon"
            icon="far fa-calendar"
            placeholder={placeholder}
            value={value}
            valueShow={dateDDMMYYFormat(value)}
            ref={this.dropdown}
            disabled={disabled}
          >
            <DayPicker
              month={new Date(new Date().setMonth(new Date().getMonth()))}
              fromMonth={fromMonth}
              toMonth={toMonth}
              selectedDays={value}
              onDayClick={this.handleDayClick}
              renderDay={day => <span id={`date-pickey-${dateYYYYMMDD(new Date(day))}`}>{new Date(day).getDate()}</span>}
              navbarElement={this.handlePaginationDatePicker}
              disabledDays={disabledDays}
            />
          </Dropdown>
        </div>
      );
    }

    return (
      <div className={`DatePicker${className ? className : ''}`}>
        <Dropdown
          id={id}
          template="a"
          placeholder={placeholder}
          value={selectType}
          valueShow={
            selectType ?
              this.handlsShowSelectType()
              : fromDate || toDate ?
                `${fromDate ? dateDDMMYYFormat(fromDate) : ''}${fromDate && toDate ? ' - ' : ''}${toDate ? dateDDMMYYFormat(toDate) : ''}`
                : null
          }
          ref={this.dropdown}
        >
          {
            allDay ?
              <div
                id="date-picker-select-all"
                className={`item${selectType === 5 ? ' active' : ''}`}
                onClick={() => this.handleSelectRange(5)}
              >
                แสดงทั้งหมด
              </div>
              : null
          }
          {this.handleShowItemType()}
        </Dropdown>
        <Modal isOpen={showCalendar} toggle={this.handleShowItem} className="Modal-DatePicker box-popup-calendar">
          <div className="bg" ref={this.calendar}>
            <div className="header">
              <div className="box-input">
                {this.handleShowHeader()}
              </div>
              <div className="box-icon">
                <span className="icon fas fa-times" id="btn-close-datepicker" onClick={this.handleShowItem} />
              </div>
            </div>
            <DayPicker
              month={new Date(new Date().setMonth(new Date().getMonth()))}
              fromMonth={new Date(2019, 0)}
              toMonth={new Date(new Date().getFullYear(), new Date().getMonth())}
              selectedDays={datePickerType === 2 ? from : [from, { from, to }]}
              numberOfMonths={2}
              modifiers={{ 'start': from, 'end': to }}
              onDayClick={this.handleSelectDate}
              renderDay={day => <span id={`date-pickey-${dateYYYYMMDD(new Date(day))}`}>{new Date(day).getDate()}</span>}
              navbarElement={this.handlePaginationDatePicker}
            />
            <div className="box-btn">
              <Button className="btn-primary comfirm" id="btn-confirm-datepicker" onClick={this.handleConfirmDate}>
                Confirm
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

DatePicker.propTypes = {
  'placeholder': PropTypes.string,
  'fromDate': PropTypes.any,
  'toDate': PropTypes.any,
  'handleSelectDate': PropTypes.func.isRequired,
  'selectType': PropTypes.number,
  'allDay': PropTypes.bool,
  'id': PropTypes.string,
  'datePickerType': PropTypes.number, // Note: 2 is select by date and 1 or null is select by range
  'template': PropTypes.string,
  'value': PropTypes.any,
  'fromMonth': PropTypes.any,
  'toMonth': PropTypes.any,
  'disabledDays': PropTypes.array,
  'disabled': PropTypes.bool,
  'className': PropTypes.string,
};
